module.exports = __webpack_public_path__ + "static/media/blank-heart.0d200672.svg";